export default __webpack_public_path__ + "static/media/ap logo main black.0ac2a4b4.png";